import Model from '@/lib/data/Model';
import FileStorageItem from '../FileStorageItem';

class ClaimInfo extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'policy_id',
        'claim_ref_number',
        'total_paid',
        'total_reserve',
        'total_declined',
        'total_paid_cur',
        'total_reserve_cur',
        'total_declined_cur',
        'note',
        {
            name: 'files',
            association: {
                type: 'many',
                model: FileStorageItem,
                collectionConfig: {
                    url: '/policy/claiminfo/files/list',
                },
            },
        },
        'visit_id',
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'saveOrUpdate',
            method: 'POST',
            url: '/policy/claiminfo/save',
            associated: true,
        },
        {
            name: 'saveOrUpdateShare',
            method: 'POST',
            url: '/policy/claiminfo/saveShare',
            associated: true,
        },
        {
            name: 'removeClaimInfo',
            url: '/policy/claiminfo/remove',
            params: ['id'],
        },
    ];
}

export default ClaimInfo;
